import React from 'react';
import { Link } from 'react-router-dom';
import { TYPE_CAT, TYPE_DOG } from '../constants/constants';
import { DOG_PROFILE } from '../constants/routesPaths';
import Recommendation from '../models/Recommendation';
import DataNormalization from '../utils/DataNormalization';
import CTAButton from './molecules/CTAButtons';

/**
 * 
 * @param {*} props 
 * pet {Object}
 * counter {Number}
 * onClick
 * @returns 
 */
function ResultPetContent(props) {

    let truncateDescription = (description, maxCharacters = 100) => {
        if (description.length >= maxCharacters) {
          let truncate = description.substring(0, maxCharacters) + "...";
          return truncate;
        } else {
          return description;
        }
      }

    return(
        <div
            onClick={() => {
                props.onClick(props.pet[Recommendation.id]);
            }}
            key={`${props.pet[Recommendation.petname]}-${
                props.pet[Recommendation.id]
            }`}
            className={"results_item-wrapper"}
            >
            <Link to={`${DOG_PROFILE}${props.pet[Recommendation.id]}/`}>
                <div className={"results_item"}>
                <div className={"results_item_image"}>
                    <img
                    src={props.pet[Recommendation.image][0]}
                    alt={props.pet[Recommendation.petname]}
                    />
                    {props.counter === 1 && (
                    <span className={"results_item_badge"}>
                        {DataNormalization.petSexMostVisits(
                            props.pet[Recommendation.sex]
                        )}
                    </span>
                    )}
                </div>
                <div className={"results_item_information"}>
                    <div className={"results_item_information-text"}>
                    <p
                        className={
                        "results_item_information-text-title"
                        }
                    >
                        {props.pet[Recommendation.petname]}
                    </p>
                    <p
                        className={
                        "results_item_information-text-description"
                        }
                    >
                        {truncateDescription(
                            props.pet[Recommendation.description]
                        )}
                    </p>
                    <div
                        className={
                        "results_item_information-properties"
                        }
                    >
                        <span className={"pet_badge pet_badge--sex"}>
                        {DataNormalization.petSexString(
                            props.pet[Recommendation.sex]
                        )}
                        </span>
                        <span className={"pet_badge pet_badge--size"}>
                        {DataNormalization.petSizeString(
                            props.pet[Recommendation.size], props.pet[Recommendation.sex]
                        )}
                        </span>
                        <span
                        className={"pet_badge pet_badge--age"}
                        >{`Edad: ${DataNormalization.petAge(props.pet[Recommendation.age])}`}</span>
                    </div>
                    </div>
                    <CTAButton
                    buttonText={"Ver detalles"}
                    onAction={() => {}}
                    position={"right"}
                    image={
                        props.pet[Recommendation.type] === TYPE_DOG
                        ? "svgs/dog_white_icon.svg"
                        : props.pet[Recommendation.type] === TYPE_CAT
                        ? "svgs/cat_white_icon.svg"
                        : ""
                    }
                    customClasses={"results-cta-button"}
                    />
                </div>
                </div>
            </Link>
            </div>
    );
}

export default ResultPetContent;